import {EMPTY_PLACEHOLDER, Nullish} from 'shared/web';

import {XENTRY_POSITION_TYPE_OPTIONS} from '../constants/xentryPositionTypeOptions';

export const getXentryPositionTypeDisplayValue = (value: string | Nullish) =>
  value
    ? (XENTRY_POSITION_TYPE_OPTIONS.find((option) => option.value === value)?.label ?? value)
    : EMPTY_PLACEHOLDER;
